import axios from '@/libs/api.request'

const Api = {
  VodSearch: '/vod/search',
  VodDetail: '/vod/detail',
  VodPlay: '/vod/play',
  VodRank: '/vod/rank',
  VodSources: '/vod/sources',
  VodLives: '/vod/lives'
}

export const getVodResult = (data) => {
  return axios.request({
    url: Api.VodSearch,
    data: data,
    method: 'post'
  })
}

export const getVodDetail = (data) => {
  return axios.request({
    url: Api.VodDetail,
    data: data,
    method: 'post'
  })
}

export const getVodRank = () => {
  return axios.request({
    url: Api.VodRank,
    method: 'get'
  })
}

export const getVodSources = () => {
  return axios.request({
    url: Api.VodSources,
    method: 'get'
  })
}

export const getVodPlayUrl = (data) => {
  return axios.request({
    url: Api.VodPlay,
    data: data,
    method: 'post'
  })
}

export const getChannels = () => {
  return axios.request({
    url: Api.VodLives,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/vod.js